/* Rathna wireframe hero carousel — Rathna-Stores-Wireframe.html */

(function () {
  var root = document.getElementById('rathna-hero-root');
  if (!root) return;

  var stores = root.parentElement
    ? root.parentElement.querySelectorAll('.rathna-hero-slide-store')
    : [];
  if (!stores.length) return;

  var slides = [];
  stores.forEach(function (store) {
    var photoPart = store.querySelector('[data-part="photo"]');
    var sidePart = store.querySelector('[data-part="side"]');
    if (!photoPart || !sidePart) return;
    var photoInner = photoPart.querySelector('.rathna-hero-photo__inner');
    slides.push({
      set: store.getAttribute('data-set') || '1',
      photoHtml: photoInner ? photoInner.outerHTML : photoPart.innerHTML,
      sideHtml: sidePart.innerHTML
    });
  });

  if (!slides.length) return;

  var heroIndex = 0;
  var heroTimer = null;
  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var autoplayMs = parseInt(root.getAttribute('data-autoplay'), 10) || 3000;

  function photoEl() {
    return root.querySelector('.rathna-hero-photo');
  }

  function sideEl() {
    return root.querySelector('.rathna-hero-side');
  }

  function updateDots() {
    root.querySelectorAll('[data-hero]').forEach(function (btn) {
      var i = Number(btn.getAttribute('data-hero')) || 0;
      var on = i === heroIndex;
      btn.classList.toggle('on', on);
      btn.setAttribute('aria-selected', on ? 'true' : 'false');
    });
  }

  function applySlide(animate) {
    var set = slides[heroIndex];
    if (!set) return;

    var photo = photoEl();
    var side = sideEl();
    var apply = function () {
      root.setAttribute('data-set', set.set);
      if (photo) {
        var inner = photo.querySelector('.rathna-hero-photo__inner');
        if (inner && set.photoHtml) {
          inner.outerHTML = set.photoHtml;
        }
      }
      if (side) side.innerHTML = set.sideHtml;
      if (side && typeof initAlpineMount === 'function') initAlpineMount(side);
      updateDots();
    };

    if (!animate || reducedMotion || !photo || !side) {
      apply();
      return;
    }

    var content = photo.querySelector('.rathna-hero-photo__content');
    if (content) content.classList.add('is-leaving');
    var media = photo.querySelector('.rathna-hero-photo__media');
    var ghost = null;
    if (media) {
      ghost = media.cloneNode(true);
      ghost.classList.add('rathna-hero-photo__ghost');
      ghost.removeAttribute('href');
      ghost.setAttribute('aria-hidden', 'true');
      photo.appendChild(ghost);
    }
    side.classList.add('is-fading');
    window.setTimeout(function () {
      apply();
      window.requestAnimationFrame(function () {
        side.classList.remove('is-fading');
        if (ghost) ghost.classList.add('is-gone');
      });
      if (ghost) {
        window.setTimeout(function () {
          if (ghost.parentNode) ghost.parentNode.removeChild(ghost);
        }, 450);
      }
    }, 320);
  }

  function goToSlide(index, animate) {
    heroIndex = ((index % slides.length) + slides.length) % slides.length;
    applySlide(animate);
    startCarousel();
  }

  function bindDots() {
    root.querySelectorAll('[data-hero]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        goToSlide(Number(btn.getAttribute('data-hero')) || 0, true);
      });
    });
  }

  function bindMobileSwipe() {
    if (slides.length < 2) return;

    var mobileMq = window.matchMedia('(max-width: 767px)');
    var swipeTarget = null;
    var startX = 0;
    var startY = 0;
    var tracking = false;
    var didSwipe = false;
    var SWIPE_MIN = 44;

    function swipeSurface() {
      return root.querySelector('.rathna-hero-photo');
    }

    function shouldIgnoreSwipeTarget(el) {
      if (!el || !el.closest) return true;
      if (el.closest('.rathna-hero-dots')) return true;
      if (el.closest('.rathna-hero-photo__content a, .rathna-hero-photo__content button')) return true;
      if (el.closest('.rathna-hero-featured__form, .rathna-hero-featured__form button')) return true;
      return false;
    }

    function onTouchStart(e) {
      if (!mobileMq.matches || e.touches.length !== 1) return;
      if (shouldIgnoreSwipeTarget(e.target)) return;
      swipeTarget = swipeSurface();
      if (!swipeTarget || !swipeTarget.contains(e.target)) return;
      startX = e.touches[0].clientX;
      startY = e.touches[0].clientY;
      tracking = true;
      didSwipe = false;
    }

    function onTouchEnd(e) {
      if (!tracking) return;
      tracking = false;
      if (!mobileMq.matches) return;
      var touch = e.changedTouches && e.changedTouches[0];
      if (!touch) return;
      var dx = touch.clientX - startX;
      var dy = touch.clientY - startY;
      if (Math.abs(dx) < SWIPE_MIN) return;
      if (Math.abs(dy) > Math.abs(dx) * 0.85) return;
      didSwipe = true;
      if (dx < 0) {
        goToSlide(heroIndex + 1, true);
      } else {
        goToSlide(heroIndex - 1, true);
      }
    }

    function onClickCapture(e) {
      if (!didSwipe) return;
      if (swipeTarget && swipeTarget.contains(e.target)) {
        e.preventDefault();
        e.stopPropagation();
      }
      didSwipe = false;
    }

    root.addEventListener('touchstart', onTouchStart, { passive: true });
    root.addEventListener('touchend', onTouchEnd, { passive: true });
    root.addEventListener('touchcancel', function () {
      tracking = false;
    }, { passive: true });
    root.addEventListener('click', onClickCapture, true);
  }

  function startCarousel() {
    if (heroTimer) clearInterval(heroTimer);
    if (slides.length < 2 || reducedMotion) return;
    heroTimer = window.setInterval(function () {
      if (!document.getElementById('rathna-hero-root')) return;
      heroIndex = (heroIndex + 1) % slides.length;
      applySlide(true);
    }, autoplayMs);
  }

  function cartRoot() {
    return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  }

  function setHeroAtcLoading(button, on) {
    if (!button) return;
    button.classList.toggle('is-loading', on);
    button.disabled = !!on;
    button.setAttribute('aria-busy', on ? 'true' : 'false');
  }

  function syncCartBadges(count) {
    var label = 'Cart, ' + count + (count === 1 ? ' item' : ' items');
    document.querySelectorAll('#cart-icon').forEach(function (link) {
      link.setAttribute('aria-label', label);
    });
    document.querySelectorAll('#cart-icon-bubble .ht-cart-count, #cart-icon-bubble .count_item, #mobile-cart-icon-bubble .count_item, #cart-icon-bubble-mobile-dock .count_item').forEach(function (badge) {
      badge.textContent = count < 100 ? String(count) : '99+';
      badge.setAttribute('data-value', String(count));
      badge.classList.toggle('hidden', count < 1);
    });
  }

  root.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form || !form.classList || !form.classList.contains('rathna-hero-featured__form')) return;
    event.preventDefault();

    var button = form.querySelector('button[name="add"]');
    if (!button || button.classList.contains('is-loading')) return;
    setHeroAtcLoading(button, true);

    var helper = window.Alpine && Alpine.store && Alpine.store('xCartHelper');
    var formData = new FormData(form);
    var sections = helper
      ? helper.getSectionsToRender().map(function (section) { return section.id; })
      : ['cart-icon-bubble', 'mobile-cart-icon-bubble', 'cart-icon-bubble-mobile-dock', 'cart-drawer'];
    formData.append('sections', sections.join(','));
    formData.append('sections_url', window.location.pathname);

    var addUrl = (window.Eurus && Eurus.cart_add_url) || (cartRoot() + 'cart/add.js');

    fetch(addUrl, {
      method: 'POST',
      headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
      body: formData
    }).then(function (response) {
      return response.json();
    }).then(function (payload) {
      if (!payload || payload.status === 422 || payload.status === '422') return null;
      if (helper && payload.sections) {
        return Promise.resolve(helper.reRenderSections(payload.sections)).then(function () {
          var drawer = document.getElementById('CartDrawer');
          if (drawer && typeof initAlpineMount === 'function') initAlpineMount(drawer);
          return fetch(cartRoot() + 'cart.js').then(function (response) { return response.json(); });
        });
      }
      return fetch(cartRoot() + 'cart.js').then(function (response) { return response.json(); });
    }).then(function (cart) {
      if (!cart || typeof cart.item_count !== 'number') return;
      syncCartBadges(cart.item_count);
      if (helper) helper.currentItemCount = cart.item_count;
      var cardQty = window.Alpine && Alpine.store && Alpine.store('xCardCartQty');
      if (cardQty && typeof cardQty.applyCart === 'function') cardQty.applyCart(cart);
      document.dispatchEvent(new CustomEvent('eurus:cart:items-changed'));
      if (window.Alpine && Alpine.store('xMiniCart')) {
        Alpine.store('xMiniCart').openCart(true);
      }
    }).catch(function () {
      /* Leave the button ready so the shopper can try again. */
    }).finally(function () {
      setHeroAtcLoading(button, false);
    });
  });

  bindDots();
  bindMobileSwipe();
  startCarousel();

  document.addEventListener('visibilitychange', function () {
    if (document.hidden) {
      if (heroTimer) clearInterval(heroTimer);
    } else {
      startCarousel();
    }
  });
})();
